"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TravelService = function TravelService(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "services__list__block"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: props.url,
    target: props.url === '#' ? '_self' : '_blank',
    rel: "noopener",
    className: "services__list__block__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "services__list__block__wrap__img"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: props.img,
    alt: props.title
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "services__list__block__wrap__title"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, props.title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "services__list__block__wrap__detail"
  }, props.detail)));
};

TravelService.propTypes = {
  title: _propTypes["default"].string,
  detail: _propTypes["default"].string,
  img: _propTypes["default"].string,
  url: _propTypes["default"].string
};
var _default = TravelService;
exports["default"] = _default;